// Chapter 12 writing frames ("מסגרות"), uploaded 1.11.2026 (Shlomo reviews them live on the site).
// One frame per step; all work on the single event the reader names in step 1.
// Mounted by App.tsx (FrameBox) at <div data-widget-anchor="ch12_fN"> in src/chapters/chapter-12.html.
// Answers persist in progress.fields under `${id}_${i}` (or `_c1`/`_c2` for two columns).
import type { Frame } from "./frames";

export const CH12_FRAMES: Frame[] = [
  {
    "id": "ch12_f1",
    "n": "12.1",
    "title": "המכונה על אירוע אחד",
    "type": "lines",
    "intro": "עובדות בלבד, בלי שיפוט. אין תשובה נכונה.",
    "fields": [
      "האירוע (מתי, מי, מה):",
      "שלב 1, מה החושים קלטו (ראיתי / שמעתי, בלי פרשנות):",
      "שלב 3, למה המוח השווה את זה (זיכרון, ניסיון קודם, דפוס):",
      "שלב 5, מה הגוף עשה (דופק, נשימה, שרירים, הזעה):",
      "\"יש סכנת מוות באירוע הזה?\" התשובה, ומה באמת היה על הפרק:",
      "קבלה: משפט אחד על עצמי אחרי האירוע, בלי שיפוט:"
    ]
  },
  {
    "id": "ch12_f2",
    "n": "12.2",
    "title": "מודעות, הקשבה, אמפתיה",
    "type": "lines",
    "intro": "",
    "fields": [
      "באותו רגע ידעתי באיזה מצב רגשי אני (כן / לא), ומה היה המצב:",
      "אילו הקשבתי באמת, מה הייתי שומעת שלא שמעתי:",
      "מה האדם השני הרגיש באותו רגע (לדעתי עכשיו):"
    ]
  },
  {
    "id": "ch12_f3",
    "n": "12.3",
    "title": "קו האמצע שלי",
    "type": "scale2",
    "intro": "1 = הפחד מנהל אותי, 10 = אדרנלין בלי חשבון. קו האמצע האישי שלי איפשהו באמצע.",
    "fields": [
      "דבר שרציתי ולא עשיתי כי פחדתי:",
      "איפה אני על הסרגל בין פחד לסיכון",
      "הסיכון המחושב האחד שלי השנה, ובאיזה חודש:"
    ]
  },
  {
    "id": "ch12_f4",
    "n": "12.4",
    "title": "עם מי",
    "type": "lines",
    "intro": "",
    "fields": [
      "השותף או השותפה שלי לסימולציה (אחד עד שלושה שמות):",
      "אני סומכת עליהם שהמטרה היא למידה ולא פגיעה (כן / לא / לא בטוחה), ולמה:"
    ]
  },
  {
    "id": "ch12_f5",
    "n": "12.5",
    "title": "הפורמט שלי",
    "type": "choice5",
    "intro": "סמני אחד, ואז שורה אחת:",
    "fields": [
      "בשניים בלי קהל · בשלושה בלי קהל · מול קהל קטן",
      "המאפשר או המאפשרת שלי (מי עוצר, ממשיך, מסיים):"
    ]
  },
  {
    "id": "ch12_f6",
    "n": "12.6",
    "title": "מה יאתגר אותי",
    "type": "lines",
    "intro": "",
    "fields": [
      "הדמות שהשחקן צריך לגלם כדי שזה יהיה קשה לי (מתרפס / אגרסיבי / שותק / צודק תמיד):",
      "איזו יכולת שלי זה בודק:",
      "מה אני חוששת שיקרה לי בתוך הסימולציה:"
    ]
  },
  {
    "id": "ch12_f7",
    "n": "12.7",
    "title": "הסצנה, המשוב, והמשפט",
    "type": "lines",
    "intro": "",
    "fields": [
      "הסימולציה שבחרתי (מהרשימה או משלי, לא השיח הכואב של עכשיו):",
      "המשפט הראשון שהשחקן אומר לי:",
      "מה אבקש מהשחקנים לספר לי אחרי (הרגשה, אמון, מה היו עושים אחרת):"
    ]
  },
  {
    "id": "ch12_f8",
    "n": "12.8",
    "title": "המסע שלי ממשיך",
    "type": "final",
    "intro": "",
    "fields": [
      "שלושת הכלים שאני לוקחת מהספר:",
      "",
      "",
      "ההרגל האחד שאתרגל כל יום ממחר:",
      "למי אלמד משהו אחד מכאן השבוע, ומה:",
      "המשפט שלי לרגע שמישהו צועק לידי:",
      "הפרק שאחזור אליו, ומתי:"
    ]
  },
  {
    "id": "ch12_f9",
    "n": "12.9",
    "title": "הספר הבא שלי",
    "type": "lines",
    "intro": "",
    "fields": [
      "המקור שהכי סקרן אותי (אחד):",
      "מה אבדוק בו (טענה מהספר שאני רוצה לראות מאיפה באה, או להתווכח איתה):"
    ]
  }
];
